module.exports = __webpack_public_path__ + "static/img/6.34a06be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/zh/6.png
// module id = ul6U
// module chunks = 0